import { type ReactNode } from 'react'

import styles from './MenuTitle.module.scss'

type Props = {
  children?: ReactNode
  icon?: ReactNode
}

export const MenuTitle = ({ children, icon }: Props) => (
  <div className={styles.container}>
    <div className={styles.icon}>{icon}</div>
    <div className={styles.content}>{children}</div>
  </div>
)
